import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Link from '@/lib/siteLink';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Services', to: '/devmob/services' },
  { label: 'Portfolio', to: '/devmob/portfolio' },
  { label: 'Cost Estimator', to: '/devmob/estimate' },
  { label: 'News', to: '/devmob/blog' },
  { label: 'About', to: '/devmob/about' },
];

export default function DevmobNav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);
  const isActive = (p) => location.pathname.startsWith(p);

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100" data-testid="devmob-navbar">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-3">
        <Link to="/devmob" className="flex items-center" data-testid="devmob-logo-link">
          <img src="/devmob-logo.png" alt="DevMob" className="h-8 w-auto" />
        </Link>
        <div className="hidden md:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${isActive(l.to) ? 'text-[#2B7DE9] font-bold' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'}`}>{l.label}</Link>
          ))}
          <Link to="/devmob/contact" className="ml-3 bg-[#2B7DE9] text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-[#1A6AD4] transition-colors" data-testid="devmob-nav-cta">Start a Project</Link>
        </div>
        <button className="md:hidden p-2 text-gray-600" onClick={() => setMobileOpen(!mobileOpen)} data-testid="devmob-mobile-menu">
          {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>
      {mobileOpen && (
        <div className="md:hidden border-t border-gray-100 bg-white px-6 py-4 space-y-1">
          {NAV_LINKS.map((l) => <Link key={l.to} to={l.to} className="block py-2 text-sm text-gray-600 hover:text-[#2B7DE9]">{l.label}</Link>)}
          <Link to="/devmob/contact" className="block py-2 text-sm font-semibold text-[#2B7DE9]">Start a Project</Link>
        </div>
      )}
    </nav>
  );
}
